import React from 'react';
import styled  from 'styled-components';
import GlyphShader from '@/components/landing/common/GlyphShaderLight';
import { ArrowRight } from 'lucide-react';
import { breakpoints } from '@/layouts/breakpoints'


const StyledComp = styled.div`
    width: 100%;
    // min-height: calc(100vh - 135px);
    height: 550px;
    overflow: hidden;
    position: relative;
    padding: clamp(20px, 5vw, 40px);
    border-bottom: 1px solid rgba(var(--greyr), 0.3);
    display: flex;
    align-items: flex-end;

    .graphic {
      overflow: hidden;
      position: absolute;
      top: 0;
      height: 100%;
      z-index: 1;
      opacity: 0.25;
      pointer-events: none;
      width: 100%;
      left: 0;
    }

    .content {
      position: relative;
      z-index: 2;
      max-width: 1400px;
      width: 100%;
      margin: 0 auto;
      background-color: rgba(var(--whiter), 0.7);
      @media (max-width: ${breakpoints.small}) {
        width: 100%;
      }

      h1 {
        line-height: 1.1;
        margin-bottom: clamp(20px, 3vw, 32px);
        color: var(--black);
        word-break: break-word;
          max-width: 600px;
      }

      p {
        font-size: clamp(16px, 2vw, 20px);
        color: var(--grey);
        line-height: 1.6;
        max-width: 700px;
        padding-bottom: 12px;
      }

      @media (max-width: ${breakpoints.medium}) {
        p{
          width: 70%;
        }
        h1{
          font-size: 50px;
          width: 80%;
        }
      }
      .hero-actions {
        display: flex;
        gap: 16px;
        margin-top: clamp(20px, 3vw, 32px);
        padding: 12px 0;
        flex-wrap: wrap;

        @media (max-width: ${breakpoints.medium}) {
          width: calc(100% - 40px);
          flex-direction: column;
        }
        a, button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 0px 20px;
          border-radius: 8px;
          font-size: clamp(13px, 1.5vw, 14px);
          text-decoration: none;
          cursor: pointer;
          transition: all 0.3s;
          white-space: nowrap;
          min-height: 44px;

          &.primary {
            background-color: var(--black);
            color: var(--white);
            border: 1px solid var(--black);

            &:hover {
              background-color: #333;
            }
          }

          &.secondary {
            background-color: transparent;
            color: var(--black);
            svg {
              transition-duration: 0.3s;
            }
            &:hover {
              background-color: #eee;
              svg {
                transform: translateX(2px);
              }
            }
          }
        }
      }
    }

`;

const Comp = ({}) => {
  return (
    <StyledComp>
      <div className="graphic center">
        <GlyphShader />
      </div>

      <div className="content">
        <h1 className="serif">
          The Financial Data  API  for Research
        </h1>
        <p>
          A market data SDK that pulls stock market data and drives insights in minutes, not months,
          backed by comprehensive SDKs and documentation for every language.
        </p>

        <div className="hero-actions">
          <a href="/docs" className="primary">
            View documentation
          </a>
          <a href="/dashboard/api-keys" className="secondary">Get An API Key <ArrowRight size={16} /> </a>
        </div>
      </div>
    </StyledComp>
  );
};

export default Comp;
